import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, Input
} from '@angular/core';
import {
  LMLoggerService, LMSpecService, LMUrlUtilService,
} from '@services/index';
import { LMGlobalUtilService } from '@utils/lm-global-util.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

@Component({
  selector: 'lm-banner-proxy-menu',
  templateUrl: './lm-banner-proxy-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMBannerProxyMenuComponent implements AfterViewInit{
  @Input() proxyUserUrls: { [ key: string ]: string };
  @Input() proxyResetUrls: [];
  @Input() proxyMode: boolean;
  @Input() proxyEnabled: boolean;
  @Input() proxyManagementLink: string;
  @Input() proxyManagementLinkMessage: string;

  proxyUsers: string[];
  proxyWebApps: any;

  constructor(
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmLoggerService: LMLoggerService,
    private lmSpecService: LMSpecService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmFormatUtilService: LMFormatUtilService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.lmLoggerService.trace('@BannerProxyMenuComponent -> constructor');
  }

  ngOnInit() {
    this.proxyManagementLinkMessage = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('ProxyManagementHyperlink'), Soho.Locale.translate('ProxyManagement'));
  }

  ngAfterViewInit(): void {
    if (this.proxyUserUrls) {
      this.proxyUsers = Object.keys(this.proxyUserUrls);
      this.proxyUsers.sort();
    }

    this.changeDetector.detectChanges();
  }

  onSwitchToProxyClicked(switchProxyUrl: string) {
    this.lmGlobalUtilService.navigate(switchProxyUrl, null, 'replace');
  }

  onProxyManagementLinkClicked(proxyManagementUrl: string) {
    this.lmGlobalUtilService.navigate(proxyManagementUrl, null, 'external');
  }

  onBeforeOpen(event: SohoPopupMenuEvent) {
    const user = event.e.currentTarget.getAttribute('user');
    this.proxyWebApps = this.proxyUserUrls[ user ];
    this.changeDetector.detectChanges();
  }

  onSelected(event: SohoPopupMenuEvent) {
    const webApp = event.args[0].getAttribute('webApp');
    const proxyWebApp = this.proxyWebApps.filter(proxyUser => proxyUser.proxyWebApp === webApp);
    window.location.href = proxyWebApp[0].proxyUserUrl;
  }

}
